import React, { useState } from "react";
import { toast } from "react-toastify";
import { useCreateClientMutation } from "services/mainApi";

const CreateClient = () => {
  const [data, setFormData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    iban: "",
    password: "",
    passcode: "",
    // personal_nr: "",
    // birthday: "",
    otp_phone_nr: "",
    country: "",
    // city: "",
    // address: "",
    // postal_code: "",
    send_otp: false,
    allow_transfer: false,
    send_welcome_email: false,
  });

  const [createClient] = useCreateClientMutation();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...data,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!data.passcode || !data.otp_phone_nr || !data.email || !data.password || !data.first_name || !data.last_name || !data.country) {
      toast.error("Please enter all the * fields.");
      return;
    }
    const result = await createClient(data);
    if ("error" in result) {
      toast.error("Error creating client.");
    } else {
      toast.success("Created Successfully");
      setFormData({
        email: "",
        first_name: "",
        last_name: "",
        iban: "",
        password: "",
        passcode: "",
        personal_nr: "",
        birthday: "",
        otp_phone_nr: "",
        country: "",
        city: "",
        address: "",
        postal_code: "",
        send_otp: false,
        allow_transfer: false,
        send_welcome_email: false,
      });
    }
  };

  const generatePasscode = () => {
    const passcode = Math.floor(100000 + Math.random() * 900000).toString();
    setFormData({ ...data, passcode });
  };

  return (
    <div className="step-2">
      <div className="w-25 m-auto mb-4">
        <small className="fw-bold my-3 text-primary">Please fill in the * fields</small>
      </div>
      <form className="w-75 m-auto">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group mb-2">
              <label className="fw-bold">Email *</label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter Email"
                onChange={handleChange}
                value={data.email}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">First Name *</label>
              <input
                name="first_name"
                type="text"
                className="form-control"
                placeholder="Enter First Name"
                onChange={handleChange}
                value={data.first_name}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">Last Name *</label>
              <input
                name="last_name"
                type="text"
                className="form-control"
                placeholder="Enter Last Name"
                onChange={handleChange}
                value={data.last_name}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">IBAN *</label>
              <input
                name="iban"
                type="text"
                className="form-control"
                placeholder="Enter IBAN"
                onChange={handleChange}
                value={data.iban}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">Password *</label>
              <input
                type="password"
                name="password"
                className="form-control"
                placeholder="Enter Password"
                onChange={handleChange}
                value={data.password}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">Passcode *</label>
              <div className="d-flex">
                <input
                  type="text"
                  name="passcode"
                  className="form-control"
                  placeholder="Enter Passcode"
                  onChange={handleChange}
                  value={data.passcode}
                />
                <button
                  type="button"
                  onClick={generatePasscode}
                  className="btn btn-primary ms-2"
                  disabled={data.passcode !== ""}
                >
                  Generate Passcode
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mb-2">
              <label className="fw-bold">Personal Nr ID</label>
              <input
                type="text"
                name="personal_nr"
                className="form-control"
                placeholder="Enter Personal Nr"
                onChange={handleChange}
                value={data.personal_nr}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">Birthday</label>
              <input
                type="date"
                name="birthday"
                className="form-control"
                placeholder="Enter Birthday"
                onChange={handleChange}
                value={data.birthday}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">Phone Number *</label>
              <input
                type="text"
                name="otp_phone_nr"
                className="form-control"
                placeholder="Enter Cel Number EX: 391234567891"
                onChange={handleChange}
                value={data.otp_phone_nr}
                required
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">Country *</label>
              <input
                type="text"
                name="country"
                className="form-control"
                placeholder="Enter Country"
                onChange={handleChange}
                value={data.country}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">City</label>
              <input
                type="text"
                name="city"
                className="form-control"
                placeholder="Enter City"
                onChange={handleChange}
                value={data?.city}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">Address</label>
              <input
                type="text"
                name="address"
                className="form-control"
                placeholder="Enter Address"
                onChange={handleChange}
                value={data?.address}
              />
            </div>
            <div className="form-group mb-2">
              <label className="fw-bold">Postal code</label>
              <input
                type="text"
                name="postal_code"
                className="form-control"
                placeholder="Enter Postal code"
                onChange={handleChange}
                value={data?.postal_code}
              />
            </div>
          </div>
        </div>
        <div className="form-group d-flex  gap-2 my-4">
          <label className="w-5 fw-bold mt-2">Fee</label>
          <input
            type="text"
            name="outgoing_fee"
            className="form-control"
            style={{ width: "10%" }}
            onChange={handleChange}
          />
          <div className="input-group-append">
            <span className="input-group-text">€</span>
          </div>
          <div className="form-group mb-2"></div>
        </div>
        <div className="form-group mb-2 d-flex gap-2 mt-4">
          <input
            className="form-check-input"
            type="checkbox"
            name="send_otp"
            onChange={handleChange}
            checked={data.send_otp}
          />
          <label className="fw-bold">Send OTP Automatically</label>
        </div>
        <div className="form-group mb-2 d-flex gap-2 mt-4">
          <input
            className="form-check-input"
            type="checkbox"
            name="allow_transfer"
            onChange={handleChange}
            checked={data.allow_transfer}
          />
          <label className="fw-bold">Allow Transfer</label>
        </div>
        <div className="form-group mb-2 d-flex gap-2 mt-4">
          <input
            className="form-check-input"
            type="checkbox"
            name="send_welcome_email"
            onChange={handleChange}
            checked={data.send_welcome_email}
          />
          <label className="fw-bold">Send Welcome SMS</label>
        </div>

        <div className="w-100 text-center mt-4">
          <button onClick={handleSubmit} className="btn btn-primary">
            Create User
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateClient;
